<h1 class="wa-heading-xl">Impressum</h1>
<section>
<h2 class="wa-heading-l">Herausgeber</h2>
<p>
  Technische Universität München<br/>
  Arcisstraße 21<br/>
  80333 München<br/>
  Telefon/Phone: +4989289-01<br/>
  <a href="mailto:poststelle@tum.de">poststelle&#64;tum.de</a>
</p>
  </section>

<section>
  <h2 class="wa-heading-l">Rechtsform und Vertretung</h2>
  Die Technische Universität München ist eine Körperschaft des Öffentlichen Rechts und staatliche Einrichtung (Art 4 Abs
  1 BayHIG). Sie wird gesetzlich vertreten durch den Präsidenten Prof. Dr. Thomas F. Hofmann.
</section>

<section>
  <h2 class="wa-heading-l">Zuständige Aufsichtsbehörde</h2>
  Bayerisches Staatsministerium für Wissenschaft und Kunst
</section>

<section>
  <h2 class="wa-heading-l">Umsatzsteueridentifikationsnummer</h2>
  DE811193231 (gemäß § 27a Umsatzsteuergesetz)
</section>

<section>
  <h2 class="wa-heading-l">Inhaltlich verantwortlich</h2>
  Prof. Dr. rer. nat. habil Hans-Joachim Bungartz<br/>
  Boltzmannstraße 3<br/>
  85748 Garching bei München<br/>
  Namentlich gekennzeichnete Internetseiten geben die Auffassungen und Erkenntnisse der genannten Personen wieder.
</section>

<section>
  <h2 class="wa-heading-l">Technische Umsetzung</h2>
  <p>Diese Website ist ein Angebot des Departments Mathematik der TUM School of Computation, Information and Technology.
    Die Server werden von der TUM School of Computation, Information and Technology betrieben.</p>
  <p>Nähere Informationen zu den gespeicherten und verwendeten Daten finden Sie in der <a href="/privacy">Datenschutzerklärung</a>.
  </p>
</section>

<section>
  <h2 class="wa-heading-l">Nutzungsbedingungen</h2>
  Texte, Bilder, Grafiken sowie die Gestaltung dieses Webauftritts können dem Urheberrecht unterliegen.
  Nicht urheberrechtlich geschützt sind nach § 5 des Urheberrechtsgesetz (UrhG)
  <ul>
    <li>Gesetze, Verordnungen, amtliche Erlasse und Bekanntmachungen sowie Entscheidungen und amtlich verfasste
      Leitsätze zu Entscheidungen und
    </li>
    <li>andere amtliche Werke, die im amtlichen Interesse zur allgemeinen Kenntnisnahme veröffentlicht worden
      sind, mit der Einschränkung, dass die Bestimmungen über Änderungsverbot und Quellenangabe in § 62 Abs. 1 bis
      3 und § 63 Abs. 1 und 2 UrhG entsprechend anzuwenden sind.
    </li>
  </ul>
  <p>
    Als Privatperson dürfen Sie urheberrechtlich geschütztes Material zum privaten und sonstigen eigenen Gebrauch
    im Rahmen des § 53 UrhG verwenden.
    Eine Vervielfältigung oder Verwendung urheberrechtlich geschützten Materials dieser Seiten oder Teilen davon
    in anderen elektronischen oder gedruckten Publikationen und deren Veröffentlichung ist nur mit unserer
    Einwilligung gestattet.
    Diese Einwilligung erteilen auf Anfrage die für den Inhalt Verantwortlichen.
  </p>
  <p>
    Weiterhin können Texte, Bilder, Grafiken und sonstige Dateien ganz oder teilweise dem Urheberrecht Dritter
    unterliegen.
    Auch über das Bestehen möglicher Rechte Dritter geben Ihnen die für den Inhalt Verantwortlichen nähere
    Auskünfte.
  </p>
</section>

<section>
  <h2 class="wa-heading-l">Haftungsausschluss</h2>
  <p>
    Alle in diesem Webauftritt bereitgestellten Informationen haben wir nach bestem Wissen und Gewissen erarbeitet
    und geprüft.
    Eine Gewähr für die jederzeitige Aktualität, Richtigkeit, Vollständigkeit und Verfügbarkeit der bereit
    gestellten Informationen können wir allerdings nicht übernehmen.
    Ein Vertragsverhältnis mit den Nutzern des Webauftritts kommt nicht zustande.
  </p>
  <p>
    Wir haften nicht für Schäden, die durch die Nutzung dieses Webauftritts entstehen.
    Dieser Haftungsausschluss gilt nicht, soweit die Vorschriften des § 839 BGB (Haftung bei Amtspflichtverletzung)
    einschlägig sind.
    Für etwaige Schäden, die beim Aufrufen oder Herunterladen von Daten durch Schadsoftware oder der Installation
    oder Nutzung von Software verursacht werden, übernehmen wir keine Haftung.
  </p>
</section>

<section>
  <h2 class="wa-heading-l">Links</h2>
  <p>
    Von unseren eigenen Inhalten sind Querverweise ("Links") auf die Webseiten anderer Anbieter zu unterscheiden.
    Durch diese Links ermöglichen wir lediglich den Zugang zur Nutzung fremder Inhalte nach § 8 Telemediengesetz.
    Bei der erstmaligen Verknüpfung mit diesen Internetangeboten haben wir diese fremden Inhalte daraufhin
    überprüft, ob durch sie eine mögliche zivilrechtliche oder strafrechtliche Verantwortlichkeit ausgelöst wird.
    Wir können diese fremden Inhalte aber nicht ständig auf Veränderungen überprüfen und daher auch keine
    Verantwortung dafür übernehmen.
    Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder
    Nichtnutzung von Informationen Dritter entstehen, haftet allein der jeweilige Anbieter der Seite.
  </p>
</section>
